import hostname from "../../../hostname";
import 'altcha';
import {useTranslation} from "react-i18next";
import {I18nService} from "../../../service/i18nService";


export const Captcha = ({
                            onSolutionVerified, onSolutionRejected = () => {
    }
                        }) => {
    const {t, i18n} = useTranslation();

    const handleMessage = (event) => {
        if (event.detail.state === 'verified') {
            onSolutionVerified();
            return;
        }
        onSolutionRejected();
    };

    const i18nService = new I18nService();
    const language = i18nService.getLanguage();

    return (
        <div className={"container"}>
            <div className={"row"}>
                <div className={"col"}>
                    <altcha-widget
                        challengeurl={hostname + "/index.php/captcha/challenge"}
                        verifyurl={hostname + "/index.php/captcha/verify"}
                        onstatechange={handleMessage}
                        auto={"off"}
                        language={language}
                        hidefooter={true}
                        hidelogo={true}
                    />
                </div>
            </div>
        </div>
    )
}